import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1F1E1D",
      "fill-rule": "evenodd",
      d: "M2.972 12c1.545 3.611 4.894 6.1 9.028 6.1 4.133 0 7.482-2.489 9.027-6.1C19.482 8.389 16.133 5.9 12 5.9c-4.134 0-7.483 2.489-9.028 6.1m-1.81-.327C2.881 7.265 6.928 4.1 12 4.1s9.117 3.165 10.838 7.573a.9.9 0 0 1 0 .654C21.117 16.735 17.07 19.9 12 19.9c-5.071 0-9.117-3.165-10.839-7.573a.9.9 0 0 1 0-.654M12 9.9a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 0 0 0-4.2M8.1 12a3.9 3.9 0 1 1 7.8 0 3.9 3.9 0 0 1-7.8 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }